(ns common.db.effects.sessionstorage
  (:require [clojure.spec.alpha :as spec]
            [common.sessionstorage :as sessionstorage]
            [re-frame.core :as rf]))

(rf/reg-fx :sessionstorage/save
  (fn [[k v]]
    (sessionstorage/save! k v)))

(rf/reg-fx :sessionstorage/remove
  (fn [[ks]]
    {:pre [(spec/assert (spec/or :set set? :seq sequential? :string string?) ks)]}
    (doseq [k (if ((some-fn sequential? set?) ks) ks [ks])]
      (sessionstorage/remove! k))))
